// pages/product/supplier/filter.jsx
import { useState } from "react"
import { Modal } from "components"
import Label from "components/forms/label"
import Input from "components/forms/input"
import InputDate from "components/forms/input-date"
import "react-datepicker/dist/react-datepicker.css"
import moment from "moment"
import { lang } from "config"
import SelectDescription from "components/forms/select-description"
import useSupplierRepositories from "repositories/supplier"

const Content = ({ data, errors, onSubmit, onRemove }) => {
    const [name, setName] = useState(data.name || "")
    const [from, setFrom] = useState(data.from || "")
    const [to, setTo] = useState(data.to || "")
    const [supplierId, setSupplierId] = useState(data.supplier_id || null)

    // ambil list supplier (sama seperti di form)
    const {
        data: supplierSelection,
        isLoading: isLoadingSupplierSelection,
    } = useSupplierRepositories({ paginate: false })

    const handleSubmit = (e) => {
        e.preventDefault()

        const payload = {
            name,
            from,
            to,
            supplier_id: supplierId,
        }

        // Filter sebelum dikirim ke parent: buang nilai null / kosong
        onSubmit(
            Object.fromEntries(
                Object.entries(payload).filter(
                    ([_, v]) => v != null && v !== ""
                )
            )
        )
    }

    return (
        <form onSubmit={handleSubmit} className="mt-8 space-y-8">
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                {/* Nama (opsional, kalau backend mau pakai) */}
                <div>
                    <Label htmlFor="name" value={lang.name} />
                    <Input
                        id="name"
                        onChange={(e) => setName(e.target.value)}
                        value={name}
                    />
                </div>

                {/* Supplier */}
                <div>
                    <Label htmlFor="supplier_id" value="Supplier" />
                    <SelectDescription
                        onChange={(value) => setSupplierId(value)}
                        selection={supplierSelection || []}
                        isLoading={isLoadingSupplierSelection}
                        value={supplierId}
                        keyValue={(value) => value.id}
                        title={(value) => value.name}
                        placeholder="Pilih Supplier"
                    />
                </div>

                {/* From date */}
                <div>
                    <Label htmlFor="from" value={lang.from} />
                    <InputDate
                        id="from"
                        maxDate={to ? Date.parse(to) : undefined}
                        onChange={(value) =>
                            setFrom(
                                value ? moment(value).format("Y-MM-DD") : ""
                            )
                        }
                        value={from ? Date.parse(from) : null}
                        selected={from ? Date.parse(from) : null}
                    />
                </div>

                {/* To date */}
                <div>
                    <Label htmlFor="to" value={lang.to} />
                    <InputDate
                        id="to"
                        minDate={from ? Date.parse(from) : undefined}
                        onChange={(value) =>
                            setTo(value ? moment(value).format("Y-MM-DD") : "")
                        }
                        value={to ? Date.parse(to) : null}
                        selected={to ? Date.parse(to) : null}
                    />
                </div>
            </div>

            <div className="flex items-center space-x-2 text-xs">
                <button
                    type="submit"
                    className="items-center px-6 py-3 text-white transition bg-brand-800 rounded-xl active:hover:scale-90"
                >
                    <span>{lang.filter}</span>
                </button>
                <button
                    type="button"
                    onClick={onRemove}
                    className="items-center px-6 py-3 transition border border-neutral-200 bg-neutral-50 rounded-xl active:hover:scale-90"
                >
                    <span>{lang.clear}</span>
                </button>
            </div>
        </form>
    )
}

const Filter = ({ data = {}, errors = {}, onSubmit, onRemove }) => {
    const [isOpen, setIsOpen] = useState(false)

    const openModal = () => setIsOpen(true)
    const closeModal = () => setIsOpen(false)

    const handleSubmit = (value) => {
        closeModal()
        onSubmit(value)
    }

    const handleRemove = () => {
        closeModal()
        onRemove()
    }

    const activeFilterCount = Object.keys(data).length

    return (
        <>
            <button
                type="button"
                onClick={openModal}
                className="inline-flex items-center px-4 py-3 space-x-2 transition border border-neutral-200 bg-neutral-50 rounded-xl active:hover:scale-90"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-4 h-4"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    strokeWidth={1}
                    stroke="currentColor"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path
                        stroke="none"
                        d="M0 0h24v24H0z"
                        fill="none"
                    ></path>
                    <path d="M5.5 5h13a1 1 0 0 1 .5 1.5l-5 5.5l0 7l-4 -3l0 -4l-5 -5.5a1 1 0 0 1 .5 -1.5"></path>
                </svg>
                <span>{lang.filter}</span>
                {activeFilterCount > 0 && (
                    <span className="inline-flex w-4 h-4 font-semibold rounded-full text-[0.5rem] justify-center text-neutral-200 bg-brand-800">
                        {activeFilterCount}
                    </span>
                )}
            </button>

            <Modal
                isOpen={isOpen}
                onClose={closeModal}
                title={`${lang.filter} ${lang.data}`}
                content={
                    <Content
                        data={data}
                        errors={errors}
                        onSubmit={handleSubmit}
                        onRemove={handleRemove}
                    />
                }
            />
        </>
    )
}

export default Filter
